import React from 'react'

import { StyledThor } from 'component-library/compositions/Thor/Thor.styled'
import { ThemeMargins, ContainerWidth } from 'component-library/__styling/settings/metrics'

export interface ThorProps {
    mainContent: React.ReactElement<any>
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
}

export type Props = ThorProps

export const Thor: React.FC<Props> = ({
    mainContent,
    hasBackgroundFill,
    horizontalGutters,
    verticalGutters,
    verticalSpacing,
    containerWidth,
}) => {
    return (
        <StyledThor
            hasBackgroundFill={hasBackgroundFill}
            horizontalGutters={horizontalGutters}
            verticalGutters={verticalGutters}
            verticalSpacing={verticalSpacing}
            containerWidth={containerWidth || 1020}
        >
            {mainContent}
        </StyledThor>
    )
}
Thor.displayName = 'ThorComposition'
